const services = [
  {
    icon: 'ri-stethoscope-line',
    title: 'Arzthaftungsrecht',
    description:
      'Ich vertrete Patienten und Ärzte bei Fragen der Arzthaftung, Behandlungsfehlern und medizinischen Schadensersatzansprüchen – fundiert und ergebnisorientiert.',
    tags: ['Behandlungsfehler', 'Schadensersatz', 'Gutachten'],
  },
  {
    icon: 'ri-file-text-line',
    title: 'Sportvertragsrecht',
    description:
      'Vertragsverhandlungen und -prüfungen für Sportler, Trainer und Vereine. Von Transferverträgen bis zu Sponsoringvereinbarungen – rechtssicher und interessengerecht.',
    tags: ['Transferverträge', 'Sponsoring', 'Lizenzrecht'],
  },
  {
    icon: 'ri-scales-line',
    title: 'Außergerichtliche Vertretung',
    description:
      'Effiziente Konfliktlösung durch außergerichtliche Mediation und Verhandlung – oft schneller und kostengünstiger als ein streitiges Gerichtsverfahren.',
    tags: ['Mediation', 'Verhandlung', 'Einigung'],
  },
  {
    icon: 'ri-hospital-line',
    title: 'Krankenhausrecht',
    description:
      'Beratung von Krankenhäusern und medizinischen Einrichtungen bei Fragen des Krankenhausrechts, Abrechnungsstreitigkeiten und regulatorischen Themen.',
    tags: ['Abrechnung', 'Regulierung', 'Haftung'],
  },
  {
    icon: 'ri-user-star-line',
    title: 'Verbandsrechtliche Verfahren',
    description:
      'Vertretung in Disziplinarverfahren, Verbandssanktionen und vor Sportschiedsgerichten – national und international.',
    tags: ['Disziplinarrecht', 'Sportschiedsgericht', 'Sanktionen'],
  },
  {
    icon: 'ri-chat-3-line',
    title: 'Erstberatung',
    description:
      'Schnelle und kompetente Ersteinschätzung Ihres Anliegens – telefonisch oder vor Ort in meiner Kanzlei in der Kröpeliner Straße in Rostock.',
    tags: ['Telefonberatung', 'Vor-Ort-Gespräch', 'Ersteinschätzung'],
  },
];

export default function ServicesSection() {
  return (
    <section id="leistungen" className="py-28 bg-[#F5F1E8]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="w-8 h-px bg-[#1A3A52]" />
              <span className="text-[#1A3A52] text-sm font-medium tracking-widest uppercase">
                Leistungen
              </span>
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-[#1A3A52] leading-tight">
              Was ich für<br />
              <span className="text-amber-500">Sie tue</span>
            </h2>
          </div>
          <p className="text-stone-500 text-base leading-relaxed max-w-md">
            Mein Leistungsspektrum umfasst alle relevanten Bereiche des Medizin- und
            Sportrechts – von der ersten Beratung bis zur vollständigen Vertretung.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={service.title}
              className={`rounded-2xl p-7 flex flex-col gap-4 hover:scale-[1.02] transition-transform duration-300 cursor-default ${
                index === 0 ? 'bg-[#1A3A52] text-white' : 'bg-white'
              }`}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl ${
                  index === 0 ? 'bg-white/15' : 'bg-[#1A3A52]/8'
                }`}
              >
                <i
                  className={`${service.icon} text-xl ${
                    index === 0 ? 'text-amber-400' : 'text-[#1A3A52]'
                  }`}
                />
              </div>
              <div>
                <h3
                  className={`text-lg font-bold mb-2 ${
                    index === 0 ? 'text-white' : 'text-[#1A3A52]'
                  }`}
                >
                  {service.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed ${
                    index === 0 ? 'text-white/70' : 'text-stone-500'
                  }`}
                >
                  {service.description}
                </p>
              </div>
              <div className="flex flex-wrap gap-2 mt-auto">
                {service.tags.map((tag) => (
                  <span
                    key={tag}
                    className={`px-3 py-1 rounded-full text-xs font-medium ${
                      index === 0
                        ? 'bg-white/10 text-white/80'
                        : 'bg-stone-100 text-stone-600'
                    }`}
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
